import { type GridCellProps } from '@progress/kendo-react-grid'
import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { HStack } from '~/components/elements/HStack'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { dialogInfoAtom } from '../atoms'
import { type AllowedDomain } from '../hooks/useMainQuery'

export type DeleteCellProps = GridCellProps & {
  dataItem: AllowedDomain
}

export const DeleteCell = ({ dataItem }: DeleteCellProps) => {
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleDeleteClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'delete', domain: dataItem })
  }, [dataItem, setDialogInfo])

  const { t } = useTranslation()

  return (
    <td>
      <HStack justifySelf="end" spacing={1}>
        <StyledButton
          buttonStyle="alert"
          fillMode="outline"
          icon="delete"
          onClick={handleDeleteClick}
        >
          {t('delete')}
        </StyledButton>
      </HStack>
    </td>
  )
}
